import { FieldViewModel, ICropping, IField, ILayerViewModel, isArrayEmpty, ISeedRateLayer, ISeedRateMap } from "./exports"
import { IPlanCropViewModel, ISeedRatePlan } from "./types"

export class PlanCropViewModel implements IPlanCropViewModel {

    expanded: boolean;

    layer: ILayerViewModel;

    selectable: boolean;

    constructor(
        public croppingVm: FieldViewModel,
        public plan: ISeedRatePlan,
        public planCropping: ISeedRateMap,
        private readonly otherPlans: ISeedRatePlan[],
        public readonly planId = plan?.SeedRatePlanId,
        public readonly varietyChanged = plan && plan.VarietyId && (plan.VarietyId !== croppingVm.varietyId),
        public readonly croppingId = croppingVm.croppingId,
        public readonly currentYear = croppingVm.currentYear,
        public readonly cropping = croppingVm.cropping,
        public readonly field = croppingVm.field,
        public readonly varietyName = croppingVm.getVarietyName(),
        public isInOtherPlans = !isArrayEmpty(otherPlans)
    ) {
    }

    get visible(): boolean {
        return this.croppingVm.visible;
    }

    getCropName(): string {
        return this.croppingVm.getCropName();
    }

    get fieldVm(): FieldViewModel {
        return this.croppingVm.fieldVm;
    }

    get hasLayer(): boolean {
        return !!this.layer;
    }

    get shouldRecalculate(): boolean {

        if (this.layer) {

            var seedsLayer = <ISeedRateLayer>this.layer.datalayer;
            return seedsLayer && seedsLayer.Seeds && seedsLayer.Seeds.ShouldRecalculate;

        }
    }

}
